import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { ApiGetContactsOptions } from '@models/contact/contact';
import { AddEmailIssueBody, EmailIssue, SaveBodyHtmlBody, SizeAndTimeEmail, UpdateEmailIssue } from '@models/email/email-issue';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailSendingService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getDefaultTitle(): Observable<any> {
    return this.http.get<Response>(this.baseUrl + 'email/sending/default-title');
  }

  addNewEmailIssueCampaign(idCampaign: number, body: AddEmailIssueBody): Observable<EmailIssue> {
    return this.http.post<EmailIssue>(this.baseUrl + 'email/sending/' + idCampaign + '/add-issue', body);
  }

  updateConfiguration(idCampaignIssue: number, body: UpdateEmailIssue): Observable<EmailIssue> {
    return this.http.put<EmailIssue>(this.baseUrl + 'email/sending/' + idCampaignIssue + '/config-issue', body);
  }

  saveBodyHtml(idCampaignIssue: number, body: SaveBodyHtmlBody): Observable<EmailIssue> {
    return this.http.post<EmailIssue>(this.baseUrl + 'email/sending/' + idCampaignIssue + '/save-body', body);
  }

  useTemplate(idCampaignIssue: number, idMailTemplate: number): Observable<EmailIssue> {
    return this.http.get<EmailIssue>(this.baseUrl + 'email/sending/' + idCampaignIssue + '/use-template/' + idMailTemplate);
  }

  getListIdsGroupsIssue(idCampaignIssue: number): Observable<any> {
    return this.http.get<Response>(this.baseUrl + 'email/sending/' + idCampaignIssue + '/issue-groups');
  }

  assignGroup(idCampaignIssue: number, groupsIds, selectionType: string): Observable<any> {
    const body = {
      groupsIds,
      selectionType
    };
    return this.http.post<any>(this.baseUrl + 'email/sending/' + idCampaignIssue + '/issue-groups', body);
  }

  assignContact(idCampaignIssue: number, contactIds, searchContactsFilter: ApiGetContactsOptions): Observable<any> {
    const body = {
      contactIds,
      searchContactsFilter
    };
    return this.http.post<any>(this.baseUrl + 'email/sending/' + idCampaignIssue + '/issue-contacts', body);
  }

  calculateSizeAndTimeEmail(idCampaignIssue: number): Observable<SizeAndTimeEmail> {
    return this.http.get<SizeAndTimeEmail>(this.baseUrl + 'email/sending/' + idCampaignIssue + '/mailing-size');
  }

  sendEmailTest(idCampaignIssue: number, emailAdressesTest: Array<string>): Observable<any> {
    const body = {
      idCampaignIssue,
      emailAdressesTest
    };
    return this.http.post(this.baseUrl + 'email/sending/test', body);
  }

  sendEmail(idCampaignIssue: number, scheduleTime?: string): Observable<any> {
    const body = {
      idCampaignIssue,
      scheduleTime: scheduleTime ? scheduleTime : null
    };
    return this.http.post(this.baseUrl + 'email/sending', body);
  }
}
